import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, delay, retryWhen, take, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request and add withCredentials only in production
    const authReq = request.clone({
      withCredentials: environment.production
    });

    return next.handle(authReq).pipe(
      retryWhen(errors => 
        errors.pipe(
          tap(err => {
            if (err.status === 0 && !environment.production) {
              console.log('Retrying due to network error...');
            }
          }),
          delay(1000), // Wait 1s before retrying
          take(3) // Max 3 retries
        )
      ),
      catchError((error: HttpErrorResponse) => {
        if (!environment.production) {
          console.error('API Error:', error);
        }
        if (error.status === 0) {
          // Network error
          return throwError('Erro de conexão. Por favor, verifique sua conexão e tente novamente.');
        }
        return throwError(error);
      })
    );
  }
} 